<template>
	<div class="main-box">
		<div class="top">
			<div class="left">
				<div class="icon-box">
					<img src="../../assets/back/title-img.png" alt="" />
				</div>
				<div class="time-box">
					<div class="current">{{ current }}</div>
					<div class="currentTime">{{ currentTime }}</div>
				</div>
			</div>
			<div class="right">
				<div class="exit" @click='goBack'>
					<div class="exit-img">
						<img src="../../assets/back/exit.png" alt="">
					</div>
					退出
				</div>
				<el-cascader :props="props" @change="selecascader" ref="myCascader"
					v-model="queryParams.companyTenantIds"></el-cascader>
			</div>
		</div>
		<!-- 统计 -->
		<div class="total">
			<div class="total-box">
				<div class="total-box-item">
					<div class="lebel">累计申请金额（{{ BankObj?.cumulativeSuperviseAmountCheckY == 1 ? '万' : BankObj?.cumulativeSuperviseAmountCheckY == 2 ? '亿': '' }}）</div>
					<div class="num-box">
						<scrollNumber :val="BankObj?.cumulativeSuperviseAmount" />
					</div>
				</div>
				<div class="total-box-item">
					<div class="lebel">累计放贷金额（{{ BankObj?.cumulativeSuperviseAmountReceiveCheckY == 1 ? '万' : BankObj?.cumulativeSuperviseAmountReceiveCheckY == 2? '亿': '' }} ）</div>
					<div class="num-box">
						<scrollNumber :val="BankObj?.cumulativeSuperviseAmountReceive" />
					</div>
				</div>
				<div class="total-box-item">
					<div class="lebel">累计还款金额（{{ BankObj?.cumulativeRepaymentAmountCheckY == 1 ? '万' : BankObj?.cumulativeRepaymentAmountCheckY == 2? '亿': '' }}）</div>
					<div class="num-box">
						<scrollNumber :val="BankObj?.cumulativeRepaymentAmount" />
					</div>
				</div>
				<div class="total-box-item">
					<div class="lebel">执行中贷款笔数（笔）</div>
					<div class="num-box">
						<scrollNumber :val="BankObj?.inSuperviseCount" />
					</div>
				</div>
				<div class="total-box-item">
					<div class="lebel">执行中贷款金额（{{ BankObj?.inSuperviseAmountCheckY == 1 ? '万' : BankObj?.inSuperviseAmountCheckY == 2? '亿': '' }}）</div>
					<div class="num-box">
						<scrollNumber :val="BankObj?.inSuperviseAmount" />
					</div>
				</div>
				<div class="total-box-item">
					<div class="lebel">执行中监管货值（{{ BankObj?.mortgageTotalAmountCheckY == 1 ? '万' : BankObj?.mortgageTotalAmountCheckY == 2? '亿': '' }}）</div>
					<div class="num-box">
						<scrollNumber :val="BankObj?.mortgageTotalAmount" />
					</div>
				</div>
			</div>
		</div>
		<div class="content">
			<div class="left">
				<div class="left-1">
					<headerTitle title="历年放款统计"></headerTitle>
					<!-- <div class="total-f">
						<div>
							<span class="title">今年放款金额(亿)：</span>
							<span class="value">25.64</span>
						</div>
						<div>
							<span class="title">笔数(笔)：</span>
							<span class="value">164</span>
						</div>
					</div> -->
					<div class="chartAmount" id="chartAmount"></div>
				</div>
				<div class="left-2">
					<div class="top-box">
						<headerTitle title="各业务放款统计"></headerTitle>
						<div class="oper">
							<el-dropdown class="mydropdown" style="color: #fff; cursor: pointer" trigger="click" @command="handleDropmenu">
								<span class="el-dropdown-link"> {{commandDate}}<i class="el-icon-caret-bottom el-icon--right"></i>
								</span>
								<el-dropdown-menu slot="dropdown">
									<el-dropdown-item v-for="(item, index) in dropdownList" :command="item" :key="index">{{ item.name }}</el-dropdown-item>
								</el-dropdown-menu>
							</el-dropdown>
						</div>
					</div>
					<div class="chartAmountPillar" id="chartAmountPillar"></div>
				</div>
				<div class="left-3">
					<div class="top-box">
						<headerTitle title="今年放款统计"></headerTitle>
						<div class="oper oper-total">
							<div class="" v-for="item in operList" :key="item.id"
								:class="['oper-btn', flagBtn === item.id ? 'active-btn' : '']" @click="handleBtn(item)">
								{{ item.text }}
							</div>
						</div>
					</div>
					<div class="card">
						<div class="card-box">
							<div class="card-box-item">
								<div class="card-box-item-top">
									<img src="../../assets/back/icon1.png" alt="" />
								</div>
								<div class="card-box-item-bottom">活畜质押</div>
							</div>
							<div class="card-box-item">
								<div class="card-box-item-top">{{ animalsObj.superviseAmount || '0.00' }}</div>
								<div class="card-box-item-bottom">授信额度({{ animalsObj.superviseAmountCheckY==1? '万元' : '亿' }})</div>
							</div>
							<div class="card-box-item">
								<div class="card-box-item-top">{{ animalsObj.superviseApplyCount || '0' }}</div>
								<div class="card-box-item-bottom">服务客户(家)</div>
							</div>
							<div class="card-box-item">
								<div class="card-box-item-top">{{ animalsObj.mortgageCount || '0' }}</div>
								<div class="card-box-item-bottom">质押活畜(头)</div>
							</div>
						</div>

						<div class="card-box">
							<div class="card-box-item">
								<div class="card-box-item-top">
									<img src="../../assets/back/icon2.png" alt="" />
								</div>
								<div class="card-box-item-bottom">仓单质押</div>
							</div>
							<div class="card-box-item">
								<div class="card-box-item-top">{{ warehouse.superviseAmount || '0.00' }}</div>
								<div class="card-box-item-bottom">授信额度({{ warehouse.superviseAmountCheckY==1? '万元' : '亿' }})</div>
							</div>
							<div class="card-box-item">
								<div class="card-box-item-top">{{ warehouse.superviseApplyCount || '0' }}</div>
								<div class="card-box-item-bottom">服务客户(家)</div>
							</div>
							<div class="card-box-item">
								<div class="card-box-item-top">{{ warehouse.mortgageTotalAmount || '0.00' }}</div>
								<div class="card-box-item-bottom">质押货值({{ warehouse.mortgageTotalAmountCheckY==1? '万元' : '亿' }} )</div>
							</div>
						</div>

						<div class="card-box">
							<div class="card-box-item">
								<div class="card-box-item-top">
									<img src="../../assets/back/icon3.png" alt="" />
								</div>
								<div class="card-box-item-bottom">无货仓单</div>
							</div>
							<div class="card-box-item">
								<div class="card-box-item-top">{{ noWarehouse.superviseAmount || '0.00' }}</div>
								<div class="card-box-item-bottom">授信额度({{ noWarehouse.superviseAmountCheckY==1? '万元' : '亿' }})</div>
							</div>
							<div class="card-box-item">
								<div class="card-box-item-top">{{ noWarehouse.superviseApplyCount || '0' }}</div>
								<div class="card-box-item-bottom">服务客户(家)</div>
							</div>
							<div class="card-box-item">
								<div class="card-box-item-top">{{ noWarehouse.purchaseInventory || '0' }}</div>
								<div class="card-box-item-bottom">采购重量(吨)</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="center">
				<div id="map" class="center-1">
					<template v-if='mapJeoData&&mapJson'>
						<echart-map ref='map' :mapJeoData='mapJeoData' :mapJson='mapJson'></echart-map>
					</template>

				</div>
				<div class="center-2">
					<headerTitle title="养殖概况"></headerTitle>
					<dv-scroll-board :config="config"
						style="width: 10.625rem; height: 2rem; margin-top: 0.1rem; margin-left: 0.25rem" />
				</div>
			</div>
			<div class="right">
				<div class="right1">
					<headerTitle title="监管动态" />
					<dv-scroll-board :config="configDynamic"
						style="width: 6rem; height: 4.25rem; margin-top: 0.1rem; margin-left: 0.25rem" />
				</div>
				<div class="right2">
					<headerTitle title="累计风险规避"></headerTitle>
					<div class="waring">
						<div class="waring-title">
							<div class="waring-title-text">经营风险</div>
							<div class="waring-title-text">市场风险</div>
							<div class="waring-title-text">道德风险</div>
						</div>
						<div class="waring-line">
							<div class="line1"></div>
							<div class="line2"></div>
							<div class="line3"></div>
						</div>
						<div class="waring-value">
							<div class="waring-title-value">{{ BankObj?.manageRiskCount || 0 }}条</div>
							<div class="waring-title-value">{{ BankObj?.marketRiskCount || 0 }} 条</div>
							<div class="waring-title-value">{{ BankObj?.moralityRiskCount || 0 }} 条</div>
						</div>
					</div>
				</div>
				<div class="right3">
					<headerTitle title="物联监控设备"></headerTitle>
					<div class="card-box">
						<div class="card-box-top">
							<div class="card-box-item">
								<div class="card-val">{{ BankObj?.deviceVideoCount }}</div>
								<img src="../../assets/back/decice1.png" alt="" />
								<div class="card-label">监控设备(个)</div>
							</div>
							<div class="card-box-item">
								<div class="card-val">{{ BankObj?.networkCount }}</div>
								<img src="../../assets/back/decice1.png" alt="" />
								<div class="card-label">网关(个)</div>
							</div>
						</div>
						<div class="card-box-bottom">
							<div class="card-box-item">
								<div class="card-val">{{ BankObj?.eartagCount }}</div>
								<img src="../../assets/back/decice1.png" alt="" />
								<div class="card-label">耳标(个)</div>
							</div>
							<div class="card-box-item">
								<div class="card-val">{{ BankObj?.bluetoothLockCount }}</div>
								<img src="../../assets/back/decice1.png" alt="" />
								<div class="card-label">电子锁(个)</div>
							</div>
							<div class="card-box-item">
								<div class="card-val">{{ BankObj?.equipmentCount }}</div>
								<img src="../../assets/back/decice1.png" alt="" />
								<div class="card-label">传感器(个)</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import scrollNumber from './components/scrollNumber.vue'
	import headerTitle from './components/headerTitle.vue'
	import echartMap from './components/echartMap.vue'
	import http from '../../http'
	import axios from 'axios'
	import mapJeoData from './components/100000.json'
	export default {
		components: {
			scrollNumber,
			headerTitle,
			echartMap
		},
		data() {
			return {
				props: {
					lazy: true,
					checkStrictly: true, //可选择任意节点
					lazyLoad: (node, resolve) => {
						const nodes = []
						const userinfo = JSON.parse(window.localStorage.getItem("USERINFO"));
						let tenantId = null
						let platformId = userinfo.platformId || 0
						let parentFlag = null
						if (node.level == 0) {
							tenantId = userinfo.tenantId || 0
							parentFlag = 1
						} else {
							tenantId = node.value
							parentFlag = node.level + 1
						}
						http({
							url: 'ffsapp-service/superviseProperty/treeListByParentId',
							//请求方式
							method: 'post',
							//传递的参数
							data: {
								parentFlag: parentFlag,
								tenantId: tenantId,
								platformId: this.queryParams.platformId,
							},
						}).then((res) => {
							console.log('*************')
							this.queryParams.companyTenantIds = res.data.result[0].tenantId

							console.log(res.data.result)
							let list = res.data.result || []
							list.map((item) => {
								let leaf = false
								if (item.childEnterpriseCount > 0) {
									leaf = false
								} else {
									leaf = true
								}
								let obj = {
									value: item.tenantId,
									label: item.deptName,
									ancestors: item.ancestors,
									companyBankType: item.companyBankType,
									leaf: leaf, // 节点级别，如果没有子节点就停止查询
									provinceId: item.provinceId,
									cityId: item.cityId,
									countyCode: item.countyCode

								}
								nodes.push(obj)
							})
							console.log(nodes)
							resolve(nodes)
						})
					},
				},
				BankObj: {},
				animalsObj: {},
				warehouse: {},
				noWarehouse: {},
				current: null,
				currentTime: null,
				val: 561.46,
				chart: null,
				flagBtn: 1,
				value: '',
				operList: [{
						id: 1,
						text: '执行中',
					},
					{
						id: 2,
						text: '全部',
					},
				],

				//todo
				time: '',
				times: [{
						label: '2019',
						value: 1
					},
					{
						label: '2020',
						value: 2
					},
					{
						label: '2021',
						value: 3
					},
					{
						label: '2022',
						value: 4
					},
					{
						label: '2023',
						value: 5
					},
				],
				growData: [],
				centerData: {
					num: 0,
					unit: '元'
				},
				config: {},
				configDynamic: {},
				queryParams: {
					ancestorsAllQuery: ['0,100,397834139791659019,1610107229657235457'],
					appId: '2015',
					companyBankType: 0,
					companyTenantId: '1610107229657235457',
					companyTenantIds: ['1610107229657235457'],
				},

				mapData: [], //养殖户地图
				mapJson: null,
				mapJeoData:null,
				superviseScreenAllList: {},
				superviseScreenYearList: {},
				dropdownList: [
					{ name: '2021年', id: 2021 },
					{ name: '2022年', id: 2022 },
					{ name: '2023年', id: 2023 },
					{ name: '2024年', id: 2024 },
      			],
			 commandDate: '2023',
			 loanCountArray: [],
			 loanAmountArray: [],
			 categoryList: [],
			 unitList: []
			}
		},

		created() {
			this.userInfo = JSON.parse(window.localStorage.getItem('USERINFO'))
			
			this.queryParams.platformId = this.userInfo.platformId
			this.getTreeListByParentId()
			// this.getBackData()

		},
		mounted() {
			this.getTime()
			console.log(11)
		},	

		methods: {
			getTreeListByParentId(){
				const userinfo = JSON.parse(window.localStorage.getItem("USERINFO"));
				
				http({
					url: 'ffsapp-service/superviseProperty/treeListByParentId',
					//请求方式
					method: 'post',
					//传递的参数
					data: {
						parentFlag: 1,
						tenantId: userinfo.tenantId,
						platformId: userinfo.platformId,
					},
				}).then((res) => {
					console.log('*************')
					this.queryParams.companyTenantIds = [res.data.result[0].tenantId]
					this.queryParams.companyTenantId = res.data.result[0].tenantId
					this.queryParams.companyBankType = res.data.result[0].companyBankType
					this.queryParams.ancestorsAllQuery = [res.data.result[0].ancestors]
					this.getQueryBankLoanByYear()
					this.getQueryBankLoanBusinessByYear()
					this.getHomeData()
					this.getBackData(res.data.result[0])
					console.log(res.data.result)
				})
			},
			goBack(){
			   this.$router.go(-1)
			},
			getMapJeoJson(provinceCode, cityCode, countyCode) {
				console.log(provinceCode, cityCode, countyCode)
				if (!provinceCode) {
					return
				}
				let url = 'https://screenapp-new02.obs.cn-north-4.myhuaweicloud.com/gjson/100000/' + provinceCode
				if (cityCode) {
					url = url + '/' + cityCode
				}
				if (countyCode) {
					url = url + '/' + countyCode
				}
				url = url + '.geoJson'
				axios.get(url).then(response => {
						// console.log(response.data);
						this.mapJeoData = response.data
					})
					.catch(error => {
						console.error('Error fetching the JSON file:', error);
					});
				return


			},
			selecascader() {
				let areaCodeData = this.$refs['myCascader'].getCheckedNodes()[0]
				this.$nextTick(() => {
					const panelRefs = this.$refs.myCascader.$refs.panel // 节点刷新，页面回显
					// panelRefs.lazyLoad(panelRefs.getCheckedNodes()[0])
					this.$refs.myCascader.dropDownVisible = false
				})
				console.log(11)
				if (this.queryParams.companyTenantIds.length > 0) {
					this.queryParams.ancestorsAllQuery = []
					this.queryParams.ancestorsAllQuery = [areaCodeData.data.ancestors]
					this.queryParams.companyBankType = areaCodeData.data.companyBankType
					this.queryParams.companyTenantId = areaCodeData.data.value
				} else {
					this.queryParams.ancestorsAllQuery = []
					this.queryParams.companyBankType = ''
					this.queryParams.companyTenantId = ''
				}
				console.log(this.queryParams)
				this.getQueryBankLoanByYear()
				this.getQueryBankLoanBusinessByYear()
				this.getHomeData()
				const {companyBankType,provinceCode,provinceId,cityId,countyId}=areaCodeData.data
				this.getBackData({companyBankType,provinceCode,provinceId,cityId,countyId})
				console.log('areaCodeData', areaCodeData)



				/**
				 * 头部：累计申请金额  累计放贷金额  累计还款金额   执行中笔数 执行中金额  执行中监管货值
				 * 左侧： 本年度放款统计
				 * 右侧： 监管动态 累积风险 物联设备
				 */
				this.$http({
					url: 'ffsapp-service/superviseProperty/bankHomePageStatistics',
					method: 'post',
					data: {
						companyTenantIds: this.queryParams.companyTenantIds,
						appId: '2105',
						companyBankType: this.queryParams.companyBankType,
						ancestorsAllQuery: this.queryParams.ancestorsAllQuery,
						companyTenantId: this.queryParams.companyTenantId,
					},
				}).then((res) => {
					let result = res.data.result
					this.BankObj = result
					console.log(this.BankObj)
					var dataArr = []
					this.BankObj?.inspectAllModels?.forEach((item) => {
						// "superviseType": 1,  1 活体2 仓单
						if (item.superviseType == 1) {
							item.superviseType = '活体'
						}
						if (item.superviseType == 2) {
							item.superviseType = '仓单'
						}
						if (item.inspectStatus == 0) {
							item.inspectStatus = '正常'
						}
						if (item.inspectStatus == 1) {
							item.inspectStatus = '异常'
						}
						dataArr.push([item.inspectStart, item.superviseType, item.applyName, item
							.inspectStatus
						])
					})
					this.configDynamic = {
						header: ['巡检时间', '监管类型', '监管客户', '巡检结果'],
						data: dataArr,
						align: ['left', 'left', 'left'],
						columnWidth: [290, 180, 180, 140],
						headerHeight: 45,
						rowNum: 7,
						waitTime: 2300,
						headerBGC: 'rgba(255, 255, 255, 0)',
						oddRowBGC: 'rgba(255,162,0,0.03)',
						evenRowBGC: 'rgba(255, 255, 255, 0)',
					}
					this.superviseScreenAllList = result?.superviseScreenAllList
					this.superviseScreenYearList= result?.superviseScreenYearList
					console.log('this.superviseScreenAllList',this.superviseScreenYearList)
					console.log(this.superviseScreenYearList)
					this.superviseScreenYearList?.forEach((item) => {
						if (item.superviseType == 1) {
							console.log(item)
							this.animalsObj = item
						} else if (item.superviseType == 2) {
							this.warehouse = item
						} else if (item.superviseType == 4) {
							this.noWarehouse = item
						}
					})
				})
			},
			getHomeData() {
				this.$http({
					url: 'ffsapp-service/superviseProperty/bankHomePageStatistics',
					method: 'post',
					data: {
						companyTenantIds: this.queryParams.companyTenantIds,
						appId: '2105',
						companyBankType: this.queryParams.companyBankType,
						ancestorsAllQuery: this.queryParams.ancestorsAllQuery,
						companyTenantId: this.queryParams.companyTenantId,
					},
				}).then((res) => {
					let result = res.data.result
					this.BankObj = result
					console.log(this.BankObj)
					var dataArr = []
					if (this.BankObj?.inspectAllModels) {
						this.BankObj.inspectAllModels.forEach((item) => {
							// "superviseType": 1,  1 活体2 仓单
							if (item.superviseType == 1) {
								item.superviseType = '活体'
							}
							if (item.superviseType == 2) {
								item.superviseType = '仓单'
							}
							if (item.inspectStatus == 0) {
								item.inspectStatus = '正常'
							}
							if (item.inspectStatus == 1) {
								item.inspectStatus = '异常'
							}
							dataArr.push([item.inspectStart, item.superviseType, item.applyName, item
								.inspectStatus
							])
						})
					}

					this.configDynamic = {
						header: ['巡检时间', '监管类型', '监管客户', '巡检结果'],
						data: dataArr,
						align: ['left', 'left', 'left'],
						columnWidth: [150, 120, 240, 120],
						headerHeight: 45,
						rowNum: 7,
						waitTime: 2300,
						headerBGC: 'rgba(255, 255, 255, 0)',
						oddRowBGC: 'rgba(255, 255, 255, 0)',
						evenRowBGC: 'rgba(255,162,0,0.03)',
					}
					
					if (result?.superviseScreenAllList) {
						this.superviseScreenAllList = result?.superviseScreenAllList
						this.superviseScreenYearList= result?.superviseScreenYearList
						this.superviseScreenYearList.forEach((item) => {
							if (item.superviseType == 1) {
								console.log(item)
								this.animalsObj = item
							} else if (item.superviseType == 2) {
								this.warehouse = item
							} else if (item.superviseType == 4) {
								this.noWarehouse = item
							}
						})
					} else {
						this.superviseScreenAllList = {}
						this.superviseScreenYearList = {}
						this.animalsObj= {}
						this.warehouse = {}
						this.noWarehouse = {}
					}

				})
			},
			// 历年放款统计
			getQueryBankLoanByYear() {
				this.$http({
					url: 'ffsapp-service/superviseProperty/queryBankLoanByYear',
					method: 'post',
					data: {
						companyTenantIds: this.queryParams.companyTenantIds,
						appId: '2105',
						companyBankType: this.queryParams.companyBankType,
						ancestorsAllQuery: this.queryParams.ancestorsAllQuery,
						companyTenantId: this.queryParams.companyTenantId,
					},
				}).then((res) => {
					console.log(res.data.result)

					let totalValue = []
					let moneyValue = []
					let label = []
					let result = res.data.result
					result.forEach((item) => {
						label.push(item.loanYear)
						totalValue.push(item.loanCount)
						moneyValue.push(item.loanAmount)
					})
					let growData = [{
							title: '贷款笔数',
							label: label,
							value: totalValue,
						},
						{
							title: '贷款金额',
							label: label,
							value: moneyValue,
						},
					]
					console.log('贷款金额', growData)
					this.initChartAmount(growData, 'chartAmount')
				})
			},
			// 各业务放款统计
			getQueryBankLoanBusinessByYear() {
				this.$http({
					url: 'ffsapp-service/superviseProperty/queryBankLoanBusinessByYear',
					method: 'post',
					data: {
						companyTenantIds: this.queryParams.companyTenantIds,
						appId: '2105',
						companyBankType: this.queryParams.companyBankType,
						ancestorsAllQuery: this.queryParams.ancestorsAllQuery,
						companyTenantId: this.queryParams.companyTenantId,
						loanYearQuery: this.commandDate
					},
				}).then((res) => {
					console.log(res)
					let result = res.data.result|| {}
					let loanCountArray = result.map(item => item.loanCount);
					let loanAmountArray = result.map(item => item.loanAmount);	
					let unitList = result.map(item => ({
						loanBusinessType: item.loanBusinessType,
						loanAmountCheckY: item.loanAmountCheckY === 1 ? "万" : item.loanAmountCheckY === 2 ? "亿" : null,
					}));
					let categoryList = [...new Set(result.map(item => {
						switch (item.loanBusinessType) {
							case 1:
							return "活体质押";
							case 2:
							return "仓单质押";
							case 3:
							return "资金质押";
							case 4:
							return "无货质押";
							default:
							return "";
						}
						}))];
					this.loanCountArray = loanCountArray
					this.loanAmountArray = loanAmountArray
					this.unitList = unitList
					this.categoryList = categoryList
					console.log('unitList', unitList)
					this.initChart('transformedData', 'chartAmountPillar')
				})
			},
			handleDropmenu(command) {
				console.log(command)
				this.commandDate = command.id
				this.getQueryBankLoanBusinessByYear()
    		},
			initChart(data, id){
				this.chart?.clear()
				this.chart = this.$echarts.init(document.getElementById(id))
			var option = {	
					grid: {
						left: 40,
						right: 30,
						top: 50,
						bottom: 20,
					},
					legend: {
						color: ['#EFAB44', '#85BC3C'],
						data: [{
								name: '贷款金额',
								textStyle: {
									color: '#EFAB44',
								},
							},
							{
								name: '贷款笔数',
								textStyle: {
									color: '#fff',
								},
							},
						],
						top: 10,
						right: 50,
						itemWidth: 10,
        				itemHeight: 10,
						textStyle: {
							fontSize: "10px", //字体大小
							color: 'rgba(255, 255, 255, 1)', //字体颜色
					    },
					},
					calculable: true,
					tooltip: {
						backgroundColor: 'rgba(255,255,255,0.8)',
						borderColor: '#292929',
						borderWidth: 1,
						textStyle: {
							color: '#EFAB44',
						},
						formatter: (params) => {
							const loanTypeMapping = {
								"活体质押": 1,
								"仓单质押": 2,
								"无货质押": 4,
							}
							let resParams = loanTypeMapping[params.name]
							var resultArr = this.unitList.filter(item => item.loanBusinessType == resParams)
							return `
							  <p style="font-size: 14px; font-weight: normal;">${params.seriesName=="贷款金额" ? `贷款金额(${resultArr[0].loanAmountCheckY})：${params.value}`: ''}</p>
							  <p style="font-size: 14px; font-weight: normal;">${params.seriesName=="贷款笔数" ? `贷款笔数(笔)：${params.value}`: ''}</p>
								
							  `
						},
					},
					xAxis: [
						{
							type: 'category',
							data: this.categoryList,
							axisLine: {
								lineStyle: {
									width: 1,
									color: 'rgba(255, 255, 255, 0.5)',
								}
							},
							axisLine: {
									show: true, // Y轴线
									symbol: ['none', 'arrow'],
									symbolSize: [6, 6],     // 轴线两端箭头大小，数值一表示宽度，数值二表示高度
									lineStyle: {
										color: 'rgba(255,255,255,0.15)',
											width: '1',    // 坐标轴线线宽
											type: 'solid',    // 坐标轴线线的类型（solid实线类型；dashed虚线类型；dotted点状类型）
										},
								},
								axisLabel: {
									color: '#FFFFFF',
								},
							axisTick: {
								show: false
							}
						}
					],
					yAxis: [
						{
							name: '亿',
							show: true,
							type: 'value',
							symbol: ['none', 'arrow'],
							nameTextStyle: {
									color: '#FFFFFF',
									padding: [3, 10, 0, 0],
								},
							axisLine: {
									show: true, // Y轴线
									symbol: ['none', 'arrow'],
									symbolSize: [6, 6],     // 轴线两端箭头大小，数值一表示宽度，数值二表示高度
									lineStyle: {
										color: 'rgba(255,255,255,0.15)',
											width: '1',    // 坐标轴线线宽
											type: 'solid',    // 坐标轴线线的类型（solid实线类型；dashed虚线类型；dotted点状类型）
										},
								},
								axisLabel: {
									color: '#FFFFFF',
								},
							splitLine: {
								lineStyle: {
									type: 'dashed',
									color: 'rgba(255,255,255,0.05)',
								},
							},
						},
						{
							name: '笔',
							show: true,
							type: 'value',
							nameTextStyle: {
									color: '#FFFFFF',
									padding: [3, 10, 0, 0],
								},
							axisLine: {
									lineStyle: {
										color: 'rgba(255,255,255,0.15)',
										},
								},
								axisLabel: {
									color: '#FFFFFF',
								},
							splitLine: {
								lineStyle: {
									type: 'dashed',
									color: 'rgba(255,255,255,0.05)',
								},
							},
						},
						//
					],
					series: [	
						{
							name: '贷款金额',
							barWidth: '10',  
							type: 'bar',
							data: this.loanAmountArray,
							yAxisIndex: 0,
							itemStyle: {
								color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1,[{
									offset: 0,   // 起点位置为左上角
                       				 color: 'rgba(239, 171, 68, 1)'  // 第一种颜色
								},
								{
									offset: 1,   // 结束位置为右下角
									color: 'rgba(239, 171, 68, 0)'  // 最后一种颜色
								}
							])
								
							}
						},
						{
							name: "贷款笔数",
							type: 'bar',
							data: this.loanCountArray,
							barWidth: '10',  
							yAxisIndex: 1,
							itemStyle: {
								color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1,[{
									offset: 0,   // 起点位置为左上角
                       				 color: 'rgba(255, 255, 255, 1)'  // 第一种颜色
								},
								{
									offset: 1,   // 结束位置为右下角
									color: 'rgba(255, 255, 255, 0)'  // 最后一种颜色
								}
							])
							}
						},
					]
				};

				this.chart?.clear()
				this.chart.setOption(option)
				window.addEventListener('resize', () => {
					this.chart.resize()
				})
			},
			// 根据区域汇总银行
			getBackData(areaCodeData) {
				this.$http({
					url: 'ffsapp-service/superviseProperty/queryBankLoanArea',
					method: 'post',
					data: {
						companyTenantIds: this.queryParams.companyTenantIds,
						appId: '2105',
						companyBankType: this.queryParams.companyBankType,
						ancestorsAllQuery: this.queryParams.ancestorsAllQuery,
						companyTenantId: this.queryParams.companyTenantId,
					},
				}).then(async (res) => {
					console.log('&&&&&&&&&&&&&&&&&',areaCodeData)



					console.log(this.$jsonp)
					console.log(res.data.result)
					this.mapJson = res.data.result.list
					// 处理地图数据，百度解析
					let provinceCode, cityCode, countyCode
					let companyBankType = areaCodeData.companyBankType
					if (companyBankType == 0) {
						this.mapJeoData = mapJeoData
					}
					if (companyBankType == 1) {
						provinceCode = areaCodeData.provinceId
						this.getMapJeoJson(provinceCode, cityCode, countyCode)
					}
					if (companyBankType == 2) {
						provinceCode = areaCodeData.provinceId
						cityCode = areaCodeData.cityId
						this.getMapJeoJson(provinceCode, cityCode, countyCode)
					}
					if (companyBankType == 3) {
						provinceCode = areaCodeData.provinceId
						cityCode = areaCodeData.cityId
						countyCode = areaCodeData.countyId
						this.getMapJeoJson(provinceCode, cityCode, countyCode)
					}

					var dataArr = []
					res.data.result.list.forEach((item, index) => {
						dataArr.push([index + 1, `${item.tenantIdName}`, item.allLoanCount, item
							.allLoanAmount, item.inLoanCount, item
							.inLoanAmount
						])
					})
					this.config = {
						header: ['排行', '网点', '累计放贷笔数', '累计放贷金额(万)', '执行中放贷笔数', '执行中放贷金额(万)'],
						data: dataArr,
						align: ['left', 'left', 'left', 'left', 'left', 'left'],
						columnWidth: [80, 300, 150, 180, 200, 200],
						headerHeight: 45,
						rowNum: 3,
						waitTime: 2000,
						headerBGC: 'rgba(255, 255, 255, 0)',
						oddRowBGC: 'rgba(255,162,0,0)',
						evenRowBGC: 'rgba(255,162,0,0.03)',
					}
				})
			},


			getTime() {
				const currentDate = new Date()
				const year = currentDate.getFullYear()
				const month = (currentDate.getMonth() + 1).toString().padStart(2, '0')
				const day = currentDate.getDate().toString().padStart(2, '0')

				const weekdays = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六']
				const dayOfWeek = weekdays[currentDate.getDay()]

				const hours = currentDate.getHours().toString().padStart(2, '0')
				const minutes = currentDate.getMinutes().toString().padStart(2, '0')
				const seconds = currentDate.getSeconds().toString().padStart(2, '0')

				this.current = `${year}年${month}月${day}日 ${dayOfWeek}`
				this.currentTime = `${hours}:${minutes}:${seconds}`

				if (this.timer) {
					clearInterval(this.timer)
				}

				this.timer = setInterval(() => {
					const currentTime = new Date()
					this.currentTime = currentTime.toLocaleTimeString([], {
						hour12: false
					})
				}, 1000)
			},
		handleListIteration(list) {
			console.log(list)
			this.animalsObj= {}
			if(list?.length>0){
				list.forEach((item) => {
					if(item.superviseType==1) {
						console.log('item', item)
						this.animalsObj = item;
					} else if(item.superviseType==2) {
						this.warehouse = item;
					} else if(item.superviseType==4) {
						this.noWarehouse = item;
					}
				});
			} else {
				this.superviseScreenAllList = {}
				this.superviseScreenYearList = {}
				this.animalsObj= {}
				this.warehouse = {}
				this.noWarehouse = {}
			}
			
		},
		handleBtn(item) {
			this.flagBtn = item.id
			console.log('superviseScreenAllList', this.superviseScreenAllList)
			console.log('superviseScreenYearList',this.superviseScreenYearList)
			if (this.flagBtn === 1) {
				console.log(11);
				this.handleListIteration(this.superviseScreenYearList);
			} else if (this.flagBtn === 2) {
				console.log(22);
				this.handleListIteration(this.superviseScreenAllList);
			}
				
		},
			initChartAmount(data, id) {
				var chart = this.$echarts.init(document.getElementById(id))
				var option = {
					legend: {
						top: 20,
						right: 50,
						itemWidth: 12,
						itemHeight: 12,
						data: [{
								name: data[1].title,
								textStyle: {
									color: '#EFAB44',
									fontSize:'10px'
								},
							},
							{
								name: data[0].title,
								textStyle: {
									color: '#EFAB44',
									fontSize:'10px'
								},
							},
						],
					},
					tooltip: {
						//鼠标悬浮提示数据
						trigger: 'axis',
						axisPointer: {
							type: 'line',
						},
						// formatter: (params) => {
						// 	return `
						// 		<p style="font-size: 14px; font-weight: normal;">${params[0].axisValue}</p><br/>
						// 		<p>
						// 		<span style="font-size: 14px; font-weight: normal;">贷款笔数(笔)： ${params[0] ? params[0].value : ''} </span>
						// 		</p ><br/>
						// 		<p>
						// 		<span style="font-size: 14px; font-weight: normal;">${params[1] ? '贷款金额(万)：' : ''} ${params[1] ? params[1].value : ''} </span>
						// 		</p>`
						// },
						formatter: (params) => {
							if (params.length == 1) {
								return `
							<p style="font-size: 14px; font-weight: normal;">${params[0].axisValue}</p><br/>
							<p>
							<span style="font-size: 14px; font-weight: normal;">${params[0].seriesName=='贷款金额'? `贷款金额:${params[0].value}`: `贷款笔数(笔):${params[0].value}`}</span>
							</p >
                         `
								// <p>
								//     <span style="font-size: 14px; font-weight: normal;">${params[0] && params[0].seriesName == '交易金额' ? '交易金额(万)：' : ''} ${params[0] && params[0].seriesName == '交易金额' ? params[0].value : ''} </span>
								// </p>
								// return params.name
							} else if (params.length == 2) {
								return `
                        <p style="font-size: 14px; font-weight: normal;">${params[0].axisValue}</p><br/>
                        <p>
                          <span style="font-size: 14px; font-weight: normal;">贷款笔数(笔)： ${params[0] ? params[0].value : ''} </span>
                        </p ><br/>
                         <p>
                          <span style="font-size: 14px; font-weight: normal;">${params[1] ? '贷款金额：' : ''} ${params[1] ? params[1].value : ''} </span>
                         </p>`
								// return params.name
							} else {
								return
							}
						},
						// backgroundColor: 'rgba(11, 15, 56, 1)',
						// borderColor: 'rgba(18, 36, 132, 1)',
						// borderWidth: 2,
						// textStyle: {
						//     color: '#fff',
						// },
						backgroundColor: 'rgba(255,255,255,0.8)',
						borderColor: '#292929',
						borderWidth: 1,
						textStyle: {
							color: '#EFAB44',
						},
					},
					grid: {
						// top: '30%',
						// left: '10%',
						// right: '13%',
						// bottom: '10%',
						left: 40,
						right: 40,
						top: 60,
						bottom: 20,
					},
					xAxis: {
						type: 'category',
						axisLabel: {
							color: '#FFFFFF',
						},
						axisLine: {
									show: true, // Y轴线
									symbol: ['none', 'arrow'],
									symbolSize: [6, 6],     // 轴线两端箭头大小，数值一表示宽度，数值二表示高度
									lineStyle: {
										color: 'rgba(255,255,255,0.15)',
											width: '1',    // 坐标轴线线宽
											type: 'solid',    // 坐标轴线线的类型（solid实线类型；dashed虚线类型；dotted点状类型）
										},
								},
						scale: false,
						axisTick: {
							// X轴线 刻度线
							// show: true,
							// inside: true,
							// alignWithLabel: true
							show: false,
						},
						data: data[0].label,
					},
					yAxis: [
						{
								name: '笔',
								nameTextStyle: {
									color: '#FFFFFF',
									padding: [3, 10, 0, 0],
								},
								type: 'value',
								splitNumber: 4,
								axisLine: {
									show: true, // Y轴线
									symbol: ['none', 'arrow'],
									symbolSize: [6, 6],     // 轴线两端箭头大小，数值一表示宽度，数值二表示高度
									lineStyle: {
										color: 'rgba(255,255,255,0.15)',
											width: '1',    // 坐标轴线线宽
											type: 'solid',    // 坐标轴线线的类型（solid实线类型；dashed虚线类型；dotted点状类型）
										},
								},
								splitLine: {
									lineStyle: {
										type: 'dashed',
										color: 'rgba(255,255,255,0.05)',
									},
								},
								axisLabel: {
									color: '#FFFFFF',
								},
						},
						{
								name: '亿',
								nameTextStyle: {
									color: '#FFFFFF',
									padding: [3, -15, 0, 0],
								},
								type: 'value',
								splitNumber: 4,
								axisLine: {
									show: false, // Y轴线
									lineStyle: {
										color: 'rgba(85, 193, 255, 1)',
									},
								},
								splitLine: {
									lineStyle: {
										type: 'dashed',
										color: 'rgba(255,255,255,0.05)',
									},
								},
								axisLabel: {
									color: '#FFFFFF',
								},
						},	
					],
					series: [
						{
							name: data[0].title,
							data: data[0].value,
							type: 'line',
							symbol: 'circle',
							barWidth: 1,
							itemStyle: {
								color: '#F5FFE7',
							},
							backgroundStyle: {
								color: 'rgba(44, 118, 254, 0.2)',
							},
						},
						{
							name: data[1]?.title,
							data: data[1]?.value,
							type: 'bar',
							barWidth: 10,
							symbol: 'circle',
							symbolSize: 5,
							yAxisIndex: 1,
							itemStyle: {
								opacity: 0.8,
								color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
										offset: 1,
										color: '#F5FFE7',
									},
									{
										offset: 0,
										color: '#EFAB44',
									},
								]),
							},
							
						},
					],
				}
				chart.clear()
				chart.setOption(option)
				window.addEventListener('resize', () => {
					chart.resize()
				})
			},




		},
	}
</script>
<style>
.el-cascader{
	margin-bottom: .0625rem;
}
.el-popper[x-placement^=bottom] .popper__arrow::after{
  border-bottom-color: rgba(239, 171, 68, 0.2);
}
.el-popper[x-placement^=bottom] .popper__arrow{
	border-bottom-color: rgba(239, 171, 68, 0.2);
}
</style>
<style scoped lang="scss">
	@import './index.scss';
	.el-dropdown-menu {
  background: rgba(239, 171, 68, 0.9);
  border: 1px solid rgba(239, 171, 68, 0.9);
}
:deep(.el-dropdown-menu){
	border: 1px solid rgba(239, 171, 68, 0.9) !important;
}
.el-dropdown-menu__item:focus,
.el-dropdown-menu__item:not(.is-disabled) {
  color: #fff;
//   rgba(181, 180, 178, 1)
}
.el-dropdown-menu__item:focus,
.el-dropdown-menu__item:not(.is-disabled):hover {
  background: rgba(239, 171, 68, 0.9);;
//   color: rgba(181, 180, 178, 1);
color: #fff;

}
.el-popper[x-placement^='bottom'] .popper__arrow::after {
  /* background: rgba(239, 171, 68, 0.2); */
  border-bottom-color: rgbargba(239, 171, 68, 0.9);;
}

.el-popper[x-placement^='bottom'] .popper__arrow {
  /* background: rgba(239, 171, 68, 0.2); */
  border-bottom-color: rgbargba(239, 171, 68, 0.9);;
  top: -7px;
}

</style>